import { Box, Grid, Typography, useTheme } from "@mui/material";

import Card from "components/Card";
import CardInvitation from "./CardInvitation";
import { LoadingButton } from '@mui/lab';
import RangeBuildCode from "./RangeBuildCode";
import { ReferralNew } from "store/api/referral";
import http from "config/http";
import useNotify from "hooks/useNotify";
import { useState } from "react";
import { actionButtonBg } from "utils/helpers/actionButtonBg";

function BuildCode({ getAllReferrals }) {
  const notify = useNotify();
  const theme = useTheme()
  
  const [loading, setLoading] = useState(false)
  const [gaugePercent, setGaugePercent] = useState(0);
  const [dataPercentFriends, setDataPercentFriends] = useState(100);

  const createCode = async () => {
    try {
      setLoading(true)

      await http.post(ReferralNew, { referralPercentChild: gaugePercent });
      getAllReferrals();
      notify("کد دعوت با موفقیت ثبت شد", "success");
    } catch (e) {
      notify(e?.response?.data?.message || "کد دعوت ثبت نشد", "error");
    }

    setLoading(false)
  };

  return (
    <Card minHeight={"455px"} marginBottom={3}>
      <Box minHeight="320px" maxHeight="320px">
        <Typography variant="h4" paddingBottom={1}>
          ساخت کد دعوت اختصاصی
        </Typography>

        <Typography
          variant="h6"
          color="text.secondary"
          paddingBottom={3}
          fontWeight={400}
        >
          نرخ کارمزد اهدایی به خود و دوستانتان را وارد کنید
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={6}>
            <CardInvitation
              title={"کارمزد دریافتی شما"}
              number={`${dataPercentFriends}%`}
            />
          </Grid>

          <Grid item xs={6}>
            <CardInvitation
              title={"کارمزد دریافتی دوستان"}
              number={`${gaugePercent}%`}
            />
          </Grid>
        </Grid>

        <RangeBuildCode
          setDataPercentFriends={setDataPercentFriends}
          setGaugePercent={setGaugePercent}
          gaugePercent={gaugePercent}
        />
      </Box>

      <Box px={6} py={3}>
        <LoadingButton variant="contained" loading={loading}
          color={actionButtonBg(theme)}
           fullWidth onClick={createCode}>
          {" "}
          ساخت کد دعوت
        </LoadingButton>
      </Box>
    </Card>
  );
}

export default BuildCode;
